import StarIcon from '@mui/icons-material/Star'
import StarOutlineIcon from '@mui/icons-material/StarOutline'
import { Box, IconButton } from '@mui/material'
import { apiFetch } from '../utils/api'
import { useContext, useEffect, useState } from 'react'
import Context from '../Context'
import { getSessionId } from '../utils/session'

function Favorite({ event, compact }) {
  const { home, away, koTime, fav, sport } = event

  const [ currentStatus, setCurrentStatus ] = useState(fav)
  const { polledHost, setIsFavoriteChanging } = useContext(Context)

  useEffect(() => {
    setCurrentStatus(fav)
  }, [fav])

  const Star = currentStatus ? StarIcon : StarOutlineIcon

  const handleChange = async () => {
    await changeFav()
  }

  const changeFav = async () => {
    const sessionId = getSessionId()
    const wanted = !currentStatus

    /**
     * The star moves on the click rather than on the answer. The feed is what says whether an event is a
     * favourite, and it is several seconds behind a change — long enough that a star which waits for it
     * reads as a click that did nothing, and gets clicked again. If the request fails it goes back.
     */
    setCurrentStatus(wanted)

    // the sport is part of what names a favourite, and the row usually knows it; when it does not the
    // server works it out from the snapshot
    const url = `/odds-comparison-change-fav?sessionId=${sessionId}&home=${encodeURIComponent(home)}`
      + `&away=${encodeURIComponent(away)}&koTime=${koTime}&add=${wanted}`
      + (sport ? `&sport=${encodeURIComponent(sport)}` : '')

    let response
    try {
      response = await apiFetch(polledHost, url)
    } catch (e) {
      setCurrentStatus(!wanted)
      throw e
    }

    setIsFavoriteChanging(prevState => !prevState)

    if (!response.ok) {
      setCurrentStatus(!wanted)
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
  }

  /**
   * The boards put six or seven rows in the space this grid gives one, so the star there is a character
   * rather than a forty pixel button — same request, same state, a fraction of the row.
   */
  if (compact) {
    return (
      <Box
        component="span"
        onClick={(event) => { event.stopPropagation(); handleChange() }}
        title={currentStatus ? 'Remove from favourites' : 'Add to favourites'}
        sx={{
          cursor: 'pointer',
          fontSize: '15px',
          lineHeight: 1,
          // the star is one character in a row of prices, so the part that answers a click is padded out
          // well past the glyph: aiming at thirteen pixels of outline is a click most people miss
          padding: '3px 5px',
          margin: '-3px 2px -3px -5px',
          borderRadius: '2px',
          color: currentStatus ? '#E8B10A' : '#C4C7CA',
          transition: 'color 0.15s, background-color 0.15s',
          '&:hover': { color: '#E8B10A', backgroundColor: '#F4F4F6' }
        }}
      >
        {currentStatus ? '★' : '☆'}
      </Box>
    )
  }

  return(
    <IconButton onClick={() => handleChange()}>
      <Star sx={{ color: 'yellow' }} />
    </IconButton>
  )
}

export default Favorite